import { useMemo } from 'react';
import { Button } from '@simplywallst/ui-core/next';
import { ROUTE_DISCOVER_INVESTING_IDEAS_MARKET } from '@/constants/routes';
import { getPath } from '@/router/utils';
import { getReadableCountry, isMarketSupported } from '@/utilities/markets';
import { getFlagCharacter } from '@/utilities/getFlagCharacter';
import useUser from '@/hooks/useUser';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import type { PrimaryCountryISO } from '@/constants/countries';

const useCountryFlag = (countryCode: PrimaryCountryISO) => {
  const { os } = useUserAgent();
  return os.toLowerCase().includes('windows')
    ? ''
    : getFlagCharacter(countryCode);
};

export const SwitchMarketButton = () => {
  const { data: user } = useUser();
  const market = (
    user.defaultMarketISO || user.countryISO
  )?.toLowerCase() as PrimaryCountryISO;
  const countryFlag = useCountryFlag(market);

  const countryDemonym = useMemo(() => {
    if (market === undefined) return;
    if (!isMarketSupported(market)) return;
    return getReadableCountry(market, 'demonym');
  }, [market]);

  if (!countryDemonym) return;

  return (
    <Button
      href={getPath({
        type: ROUTE_DISCOVER_INVESTING_IDEAS_MARKET,
        payload: { market: market },
      })}
      variant="subtle"
      size="large"
      className="h-8"
    >
      {countryFlag && (
        <span className="mr-0.5" aria-hidden="true">
          {countryFlag}{' '}
        </span>
      )}
      Switch to {countryDemonym} market
    </Button>
  );
};
